module.exports = "/images/img_bookingempty.png?300f31d5594b777824512c366b991012";